import {IntlProvider} from 'react-intl';
import {locale} from 'shared/core';
import getMessages from 'messages';

const oppositeLocale = locale === 'en' ? 'fr' : 'en';
const primaryMessages = getMessages(locale);
const oppositeMessages = getMessages(oppositeLocale);

const bilingualMessages = Object.fromEntries(
  Object.entries(primaryMessages).map(([key, value]) => {
    const opposite = oppositeMessages[key];
    return [key, `${value} / ${opposite}`];
  })
);

const BilingualProvider = ({bilingual, children}) => {
  if (!bilingual) return children;

  return (
    <IntlProvider locale={locale} messages={bilingualMessages}>
      {children}
    </IntlProvider>
  );
};

export default BilingualProvider;
